import React, { useState, useEffect } from "react";
import { FormGroup, Label, Input, Row, Col } from "reactstrap";

const days = [
  "Saturday",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

export default function WorkingDaysWidget({
  initialWorkingHours = {},
  onChange,
}) {
  // Initialize working hours state from initialWorkingHours
  const [workingHours, setWorkingHours] = useState(() => {
    const normalizedHours = days.reduce((acc, day) => {
      acc[day] = initialWorkingHours[day] ?? null;
      return acc;
    }, {});
    console.log("WorkingDaysWidget initialized with:", normalizedHours);
    return normalizedHours;
  });

  // Sync with initialWorkingHours when it changes
  useEffect(() => {
    const normalizedHours = days.reduce((acc, day) => {
      acc[day] = initialWorkingHours[day] ?? null;
      return acc;
    }, {});
    console.log(
      "WorkingDaysWidget updated initialWorkingHours:",
      normalizedHours
    );
    setWorkingHours(normalizedHours);
  }, [initialWorkingHours]);

  // Notify parent on workingHours update
  useEffect(() => {
    console.log("WorkingDaysWidget workingHours changed:", workingHours);
    onChange && onChange(workingHours);
  }, [workingHours, onChange]);

  const handleToggle = (day) => {
    setWorkingHours((prev) => ({
      ...prev,
      [day]: prev[day] ? null : { start: "", end: "", is24Hours: false },
    }));
  };

  const handleTimeChange = (day, type, value) => {
    setWorkingHours((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        [type]: value,
        is24Hours: false,
      },
    }));
  };

  const handle24HourToggle = (day) => {
    setWorkingHours((prev) => {
      const isCurrently24 = prev[day]?.is24Hours;
      return {
        ...prev,
        [day]: {
          start: isCurrently24 ? "" : "00:00",
          end: isCurrently24 ? "" : "23:59",
          is24Hours: !isCurrently24,
        },
      };
    });
  };

  return (
    <>
      <div className="p-3 mt-4 bg-white rounded border">
        <p>Working Days</p>
        {days.map((day) => {
          const isChecked = !!workingHours[day];
          const is24Hours = workingHours[day]?.is24Hours;

          return (
            <div key={day} className="mb-3 p-2 border rounded bg-gray-50">
              <Row className="align-items-center mb-2">
                <Col xs="6" className="d-flex align-items-center gap-2">
                  <FormGroup switch>
                    <Input
                      type="switch"
                      checked={isChecked}
                      onChange={() => handleToggle(day)}
                    />
                    <Label check>{day}</Label>
                  </FormGroup>
                </Col>
                <Col xs="6" className="text-end">
                  {isChecked && (
                    <FormGroup switch className="d-inline-block">
                      <Input
                        type="switch"
                        checked={is24Hours}
                        onChange={() => handle24HourToggle(day)}
                      />
                      <Label check className="text-muted">
                        24 Hours
                      </Label>
                    </FormGroup>
                  )}
                </Col>
              </Row>

              {isChecked && !is24Hours && (
                <Row>
                  <Col>
                    <Input
                      type="time"
                      value={workingHours[day]?.start || ""}
                      onChange={(e) =>
                        handleTimeChange(day, "start", e.target.value)
                      }
                    />
                  </Col>
                  <Col className="text-center pt-2 text-muted">to</Col>
                  <Col>
                    <Input
                      type="time"
                      value={workingHours[day]?.end || ""}
                      onChange={(e) =>
                        handleTimeChange(day, "end", e.target.value)
                      }
                    />
                  </Col>
                </Row>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
